import firebase from '@/firebase'
import { csvJSON, downloadFile } from '@/utils/csv'

export async function importCsv(file, reserveId, speciesSlugs, trees) {
  console.log('speciesSlugs: ', speciesSlugs)
  const array = csvJSON(file)

  const col = firebase.firestore.collection('reserves').doc(reserveId).collection('trees')
  
  var errors = []
  for (const index in array) {
    const item = array[index]
    console.log('item: ', item)
    const specieId = speciesSlugs[item.Especie]
    if (!specieId) {
      console.log('La especie no existe', item)
      errors.push({item: item, error: 'La especie no existe'})
      continue
    }
    const lat = item.Lat ? parseFloat(item.Lat.replace(/,/g, '.')) : 0.0
    const lng = item.Lon ? parseFloat(item.Lon.replace(/,/g, '.')) : 0.0
    const alt = item.Alt ? parseFloat(item.Alt.replace(/,/g, '.')) : 0.0
    const altura = item.Altura ? parseFloat(item.Altura.replace(/,/g, '.')) : 0.0
    const dmtr = item.Diametro ? parseFloat(item.Diametro.replace(/,/g, '.')) : 0.0
    const accuracy = item.accuracy ? parseFloat(item.accuracy.replace(/,/g, '.')) : 0.0
    if (lat == 0) {
      console.log('Latitud incorrecta', item)
      errors.push({item: item, error: 'Latitud incorrecta'})
      continue
    }
    if (lng == 0) {
      console.log('Longitud incorrecta', item)
      errors.push({item: item, error: 'Longitud incorrecta'})
      continue
    }

    var date = new Date().getTime()
    if (item.created) {
      // 2018-08-27-18-53-00
      const comps = item.created.split('-')
      if (comps.length == 6) {
        date = new Date(parseInt(comps[0]), parseInt(comps[1]) - 1, parseInt(comps[2]), parseInt(comps[3]), parseInt(comps[4]), parseInt(comps[5])).getTime()
      }
    }

    // Check stored
    var stored = false
    const csvLatLng = item.Lat+'-'+item.Lon
    for (const index in trees) {
      const tree = trees[index]
      if (tree.csvLatLng === csvLatLng) {
        stored = true
        break
      }
    }
    
    if (stored) {
      console.log('Ya existe un árbol con la misma latitud y longitud', item)
      errors.push({item: item, error: 'Ya existe un árbol con la misma latitud y longitud'})
      continue
    }

    const tree = {
      date: date,
      specie: specieId,
      position: {
        lat: lat,
        lng: lng,
        alt: alt,
        altura: altura,
        dmtr: dmtr,
        accuracy: accuracy
      },
      csvLatLng: item.Lat+'-'+item.Lon
    }

    const success = await col.add(tree)
    if (!success) {
      console.log('Error al guardarlo en la BD', item)
      errors.push({item: item, error: 'Error al guardarlo en la BD'})
    }
  }
  downloadErrors(errors)
}

function downloadErrors(errors) {
  var text = ''
  if (errors.length > 0) {
    text = 'No se han podido importar los siguientes árboles:\n'
    errors.forEach(item => {
      text += '\n\nmotivo: '+item.error+'\n'
      text += 'árbol: '+JSON.stringify(item.item,null, 2)
    });  
  } else {
    text = 'Exito!!!\n\nSe han importado todos los árboles satisfactoriamente.'
  }

  downloadFile(text, 'log_errors.txt')
}


// WEBPACK FOOTER //
// ./src/utils/csvImporter.js